module.exports = __webpack_public_path__ + "static/media/sip_corpus_switch.291a35b2.svg";